// resources/js/utils/quiz-status-poll.js
// Model-driven status poller using the project's axios API instance.
// Polls /quiz/{quizId} until status changes away from "scheduled".

import api from "../api/axios-api";

export function startQuizStatusPolling({
        quizId,
        intervalMs = 1500,
        readStatus = (payload) => {
            // Accept either { quiz: {...} } or a flat payload with status fields.
            const q = payload?.quiz ?? payload;
            // Prefer explicit flags if present
            if (typeof q?.is_open === 'boolean' || typeof q?.is_closed === 'boolean') {
                if (q.is_open === true) return 'open';
                if (q.is_closed === true) return 'closed';
            }
            // Fallback to status string if provided
            return (q?.status ?? '').toString().toLowerCase();
        },
        onAdvance = async (_payload) => {},
        onTick = (_payload) => {},
    }) {
    if (!quizId) throw new Error("startQuizStatusPolling: quizId is required");

    let stopped = false;
    let timer = null;
    let backoff = intervalMs;
    let fired = false;

    async function tick() {
        if (stopped) return;
        try {
            const { data } = await api.get(`/quiz/${quizId}`);
            const payload = data?.data ?? data; // support { data: {...} } or direct
            onTick(payload);

            const status = readStatus(payload);
            const isScheduled = !status || status === 'scheduled';
            if (!isScheduled && !fired) {
                fired = true;
                await onAdvance(payload);
                stop();
                return;
            }
            backoff = intervalMs; // reset backoff on success
        } catch (e) {
            console.warn("[quiz-status-poll] tick error:", e);
            backoff = Math.min(backoff * 2, 10000);
        }
        timer = setTimeout(tick, backoff);
    }

    function stop() {
        if (stopped) return;
        stopped = true;
        if (timer) clearTimeout(timer);
    }

    tick();
    return { stop };
}
